var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"card-img",class:_vm.styleNotFound(),attrs:{"src":_vm.suitImage.src},on:{"click":function($event){return _vm.showQuiz()}}})}
var staticRenderFns = []

export { render, staticRenderFns }